export const goldenTrianglePackage = {
  id: "golden-triangle-6n7d",
  title: "Golden Triangle India Tour",
  country: "India",
  days: 7,
  nights: 6,
  price: {
    adult: "₹52,500 per adult + 5% GST + 5% TCS",
    childWithBed: "₹45,000 per child (with bed) + 5% GST + 5% TCS",
    childNoBed: "₹40,500 per child (no bed) + 5% GST + 5% TCS",
  },

  thumbnail:
    "https://images.pexels.com/photos/602607/pexels-photo-602607.png",

  description:
    "Discover the rich history, culture, and architecture of India on this Golden Triangle tour covering Delhi, Agra, and Jaipur. Explore ancient forts, majestic palaces, bustling bazaars, and the iconic Taj Mahal in a 7-day guided journey.",

  highlights: [
    "Sightseeing in Delhi: India Gate, Qutub Minar, Humayun's Tomb, Lotus Temple",
    "Agra: Taj Mahal, Agra Fort, Mehtab Bagh",
    "Jaipur: Amber Fort, City Palace, Jantar Mantar, Hawa Mahal",
    "Local markets & bazaars in Jaipur and Delhi",
    "Cultural experiences and traditional Rajasthani hospitality",
    "Evening heritage walks & photography opportunities",
  ],

  included: [
    "Accommodation on twin sharing basis",
    "Breakfast and Dinner at hotels (Lunch as per itinerary)",
    "All transfers & sightseeing in an AC vehicle",
    "All entrance fees for listed sightseeing",
    "Services of a local tour manager throughout the tour",
    "Travel insurance up to 60 years of age",
  ],

  excluded: [
    "5% GST & 5% TCS",
    "Airfare / train fare to start city",
    "Porterage, laundry, telephone, shopping, and personal expenses",
    "Meals other than specified",
    "Alcoholic beverages & mineral water (unless specified)",
    "Extra expenses due to unforeseen circumstances, strikes, or natural calamities",
    "Private transfers if taken instead of coach",
    "Upgradation in airline class or hotel room category",
    "Anything not specifically mentioned in inclusions",
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival – Delhi",
      description:
        "Arrive in Delhi and transfer to hotel. Relax after your journey. Evening guided heritage walk in Connaught Place. Overnight in Delhi.",
      photo: "https://images.pexels.com/photos/34149324/pexels-photo-34149324.jpeg",
    },
    {
      day: 2,
      title: "Delhi City Tour",
      description:
        "After breakfast, full-day sightseeing covering Qutub Minar, India Gate, Humayun's Tomb, Lotus Temple, and Red Fort. Explore local markets in the evening. Overnight in Delhi.",
      photo: "https://images.pexels.com/photos/18567617/pexels-photo-18567617.jpeg",
    },
    {
      day: 3,
      title: "Delhi – Agra",
      description:
        "Drive to Agra. Visit Agra Fort and Mehtab Bagh. Evening visit to the Taj Mahal for sunset photography. Overnight stay in Agra.",
      photo: "https://images.pexels.com/photos/3881104/pexels-photo-3881104.jpeg",
    },
    {
      day: 4,
      title: "Agra – Jaipur via Fatehpur Sikri",
      description:
        "After breakfast, drive to Jaipur en route visiting the UNESCO site Fatehpur Sikri. Check-in at Jaipur hotel and relax. Overnight in Jaipur.",
      photo: "https://images.pexels.com/photos/4476380/pexels-photo-4476380.jpeg",
    },
    {
      day: 5,
      title: "Jaipur Sightseeing",
      description:
        "Full-day sightseeing in Jaipur covering Amber Fort, City Palace, Jantar Mantar, Hawa Mahal, and local markets. Enjoy Rajasthani cultural performances in the evening. Overnight in Jaipur.",
      photo: "https://images.pexels.com/photos/209374/pexels-photo-209374.jpeg",
    },
    {
      day: 6,
      title: "Jaipur – Delhi",
      description:
        "After breakfast, drive back to Delhi. Afternoon free for leisure or shopping. Overnight stay in Delhi.",
      photo: "https://images.pexels.com/photos/6440428/pexels-photo-6440428.jpeg",
    },
    {
      day: 7,
      title: "Departure from Delhi",
      description:
        "After breakfast, check out and transfer to Delhi airport/railway station for onward journey. Tour ends with happy memories.",
      photo: "https://images.pexels.com/photos/4059538/pexels-photo-4059538.jpeg",
    },
  ],

  gallery: [
    // Day-wise images
    "https://images.pexels.com/photos/34149324/pexels-photo-34149324.jpeg", // Day 1 Delhi
    "https://images.pexels.com/photos/18567617/pexels-photo-18567617.jpeg", // Day 2 Delhi
    "https://images.pexels.com/photos/3881104/pexels-photo-3881104.jpeg", // Day 3 Agra
    "https://images.pexels.com/photos/4476380/pexels-photo-4476380.jpeg", // Day 4 Fatehpur Sikri
    "https://images.pexels.com/photos/209374/pexels-photo-209374.jpeg",   // Day 5 Jaipur
    "https://images.pexels.com/photos/6440428/pexels-photo-6440428.jpeg", // Day 6 Jaipur-Delhi
    "https://images.pexels.com/photos/4059538/pexels-photo-4059538.jpeg", // Day 7 Departure

    // Existing extra gallery shots
    "https://images.pexels.com/photos/34088513/pexels-photo-34088513.jpeg",
    "https://images.pexels.com/photos/3581368/pexels-photo-3581368.jpeg",
    "https://images.pexels.com/photos/19149579/pexels-photo-19149579.jpeg",
    "https://images.pexels.com/photos/16745021/pexels-photo-16745021.jpeg",
    "https://images.pexels.com/photos/1007426/pexels-photo-1007426.jpeg",
    "https://images.pexels.com/photos/14388684/pexels-photo-14388684.jpeg"
  ],

  groupDates: [
    { group: "Group 1", start: "2025-09-15", end: "2025-09-21" },
    { group: "Group 2", start: "2025-10-05", end: "2025-10-11" },
    { group: "Group 3", start: "2025-11-10", end: "2025-11-16" },
    { group: "Group 4", start: "2025-12-05", end: "2025-12-11" },
  ],

  brochure:
    "https://firebasestorage.googleapis.com/v0/b/paryatakadmin.firebasestorage.app/o/packages%2Fgolden_triangle_brochure.pdf?alt=media&token=example",

  rating: {
    stars: 4.7,
    reviews: 110,
  },

  reviews: [
    {
      stars: 5,
      review: "Loved the Taj Mahal and Amber Fort! Great trip for history lovers.",
      name: "Sonia Mehta",
    },
    {
      stars: 4,
      review: "Smooth transport and good hotels. Jaipur markets were fantastic!",
      name: "Amit Sharma",
    },
    {
      stars: 5,
      review: "Well-planned itinerary, enjoyed every city. Guide was very knowledgeable.",
      name: "Priya Nair",
    },
  ],
};
